import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntMonthCellComponent} from "./int-month-cell.component";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IntMonthCellComponent
  ],
  exports: [
    IntMonthCellComponent
  ]
})
export class IntMonthCellModule {}
